import React from "react";
import { useLocation, Link } from "react-router-dom";
import { SubMenu, MenuItem } from "react-pro-sidebar";
import SVG from "react-inlinesvg";
import { BsFuelPump } from "react-icons/bs";
import Reports from "../assets/images/icons/reports.svg";

const TMSMenu = () => {
  const location = useLocation();

  const closeSidebar = () => {
    const event = new Event("sidebar:close");
    window.dispatchEvent(event);
  };

  return (
    <SubMenu
      label={"TMS"}
      icon={<SVG src={Reports} width={"25px"} height={"25px"} />}
      className="sub-menu"
      expandicon={<BsFuelPump />}
    >
      <MenuItem
        active={location.pathname === "/tms/trip-dashboard"}
        component={<Link to="/tms/trip-dashboard" />}
        onClick={closeSidebar}
      >
        Trips
      </MenuItem>
      <MenuItem
        active={location.pathname === "/tms/routes"}
        component={<Link to="/tms/routes" />}
        onClick={closeSidebar}
      >
        Routes
      </MenuItem>
      {/* <MenuItem
        active={location.pathname === "/tms/address_book"}
        component={<Link to="/tms/address_book" />}
        onClick={closeSidebar}
      >
        Address Book
      </MenuItem> */}
      <MenuItem
        active={location.pathname === "/tms/clients"}
        component={<Link to="/tms/clients" />}
        onClick={closeSidebar}
      >
        Clients
      </MenuItem>
      <MenuItem
        active={location.pathname === "/tms/commodities"}
        component={<Link to="/tms/commodities" />}
        onClick={closeSidebar}
      >
        Commodity
      </MenuItem>
      <MenuItem
        active={location.pathname === "/tms/Firms"}
        component={<Link to="/tms/Firms" />}
        onClick={closeSidebar}
      >
        Firms
      </MenuItem>
      <MenuItem
        active={location.pathname === "/tms/Driver"}
        component={<Link to="/tms/Driver" />}
        onClick={closeSidebar}
      >
        Driver
      </MenuItem>
      <MenuItem
        active={location.pathname === "/tms/Vendors"}
        component={<Link to="/tms/Vendors" />}
        onClick={closeSidebar}
      >
        Vendors
      </MenuItem>
    </SubMenu>
  );
};

export default TMSMenu;
